import { useState } from "react";
import { motion } from "framer-motion";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import MarqueeSection from "../components/MarqueeSection";
import HowWeWorkSection from "../components/HowWeWorkSection";
import FounderSection from "../components/FounderSection";
import PricingSection from "../components/PricingSection";
import AISection from "../components/AISection";
import NetworkSection from "../components/NetworkSection";
import GlobeSection from "../components/GlobeSection";
import ProcessSection from "../components/ProcessSection";
import FinalCTASection from "../components/FinalCTASection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import NewsletterPopup from "../components/NewsletterPopup";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0B] relative overflow-x-hidden">
      <div className="relative z-10">
        <Header />
        <main>
          <HeroSection />
          <MarqueeSection />
          <HowWeWorkSection />
          <FounderSection />
          <PricingSection />
          <AISection />
          <NetworkSection />
          <GlobeSection />
          <ProcessSection />
          <FinalCTASection />
          <ContactSection />
        </main>
        <Footer />
      </div>
      <NewsletterPopup />
    </div>
  );
}
